import { render } from "./error-store.vue?vue&type=template&id=bafd7fe4"
import script from "./error-store.vue?vue&type=script&lang=js"
export * from "./error-store.vue?vue&type=script&lang=js"

import "./error-store.vue?vue&type=style&index=0&id=bafd7fe4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__